export enum UserActionEnum {
  RESPONSE_TEMPLATES_ADD
}
